import { useEffect, useState } from "react";
import { Palette, Check } from "lucide-react";
import { THEMES, getStoredTheme, setTheme } from "@/lib/theme";

export default function ThemeSwitch() {
  const [active, setActive] = useState(getStoredTheme());
  const [open, setOpen] = useState(false);

  useEffect(() => { setTheme(active); }, [active]);

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (!e.target.closest("[data-testid='theme-popover']") && !e.target.closest("[data-testid='theme-trigger']")) {
        setOpen(false);
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);

  return (
    <div className="relative">
      <button
        data-testid="theme-trigger"
        onClick={() => setOpen((o) => !o)}
        className="relative w-10 h-10 rounded-full bg-white/70 border hairline hover:border-coral/60 hover:bg-cream-card transition flex items-center justify-center text-ink"
        aria-label="Cambiar paleta"
      >
        <Palette className="w-[18px] h-[18px]" strokeWidth={1.7} />
      </button>

      {open && (
        <div
          data-testid="theme-popover"
          className="absolute right-0 mt-2 w-72 bg-cream-card border hairline rounded-2xl shadow-xl z-50 p-2"
        >
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink-mid px-3 pt-2 pb-1">
            Paleta de la interfaz
          </p>
          {THEMES.map((t) => {
            const selected = active === t.id;
            return (
              <button
                key={t.id}
                data-testid={`theme-option-${t.id}`}
                onClick={() => { setActive(t.id); setOpen(false); }}
                className={`w-full flex items-center gap-3 p-3 rounded-xl text-left transition ${
                  selected ? "bg-cream-deep" : "hover:bg-cream-deep/60"
                }`}
              >
                <span
                  className="w-9 h-9 rounded-lg shrink-0 ring-1 ring-black/10"
                  style={{ background: `linear-gradient(135deg, ${t.swatch} 0%, ${t.bg} 100%)` }}
                />
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium text-ink">{t.name}</span>
                  <span className="block text-[11px] text-ink-mid truncate">{t.sub}</span>
                </span>
                {selected && <Check className="w-4 h-4 text-coral shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
